"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Logger_1 = require("./Logger");
const timer = (category, label) => {
    // tslint:disable-next-line:ban-types
    return (_target, key, descriptor) => {
        const originalMethod = descriptor.value;
        if (!originalMethod) {
            return descriptor;
        }
        descriptor.value = function (...args) {
            const time = performance.now();
            const result = originalMethod.apply(this, args);
            result.then(() => {
                Logger_1.Logger.logCustomTiming({ category, key, label, time: Math.round(performance.now() - time) });
            }).catch((e) => {
                // Maybe this is too much, but we'll see
                Logger_1.Logger.logCustomTiming({
                    category,
                    key: `${key} - Exception: ${e.message}`,
                    label,
                    time: Math.round(performance.now() - time)
                });
            });
            return result;
        };
        return descriptor;
    };
};
exports.default = timer;
